import { Routes } from '@angular/router';
import { DialogNames, LazyDialogLoader } from '@qtek/libs/dialog-loader';
import { defaultDialogConfig } from './default-config';
import { contactPreviewDialogConfig } from './module-dialogs/contact-preview-dialog/contact-preview-dialog.component';
import { employeeDialogConfig } from './standalone-dialogs/employee-dialog/employee-dialog.component';
import { informationDialogConfig } from './standalone-dialogs/information-dialog/information-dialog.component';
import { inviteContactDialogConfig } from './standalone-dialogs/invite-contact-dialog/invite-contact-dialog.component';
import { createParticipantDialogConfig } from './standalone-dialogs/create-participant-dialog/create-participant-dialog.component';
import { ndaDialogConfig } from './standalone-dialogs/nda-dialog/nda-dialog.component';
import { dealTypeSelectionDialogConfig } from './standalone-dialogs/deal-type-selection-dialog/deal-type-selection-dialog.component';
import { closedDealStepperDialogConfig } from './standalone-dialogs/closed-deal-stepper-dialog/closed-deal-stepper-dialog.component';
import { closedDealEntryMethodDialogConfig } from './standalone-dialogs/closed-deal-entry-method-dialog/closed-deal-entry-method-dialog.component';
import { currentDealEntryMethodDialogConfig } from './standalone-dialogs/current-deal-entry-method-dialog/current-deal-entry-method-dialog.component';
import { termSheetReviewDialogConfig } from './standalone-dialogs/term-sheet-review-dialog/term-sheet-review-dialog.component';
import { benchmarkPublishDialogConfig } from './standalone-dialogs/benchmark-publish-dialog/benchmark-publish-dialog.component';

export const dialogRoutes: Routes = [
  //
  // STANDALONE   ////////////////////////////////////
  //
  {
    path: DialogNames.alert,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: '600px',
        maxWidth: '80vw',
        maxHeight: '80vh',
        autoFocus: false,
      },
    },
    loadComponent: () =>
      import('./standalone-dialogs/alert-dialog/alert-dialog.component').then(
        c => c.AlertDialogComponent
      ),
  },
  {
    path: DialogNames.confirm,
    canActivate: [LazyDialogLoader],
    data: { dialogConfig: { autoFocus: false } },
    loadComponent: () =>
      import(
        './standalone-dialogs/confirm-dialog/confirm-dialog.component'
      ).then(c => c.ConfirmDialogComponent),
  },

  {
    path: DialogNames.selectPlan,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        disableClose: true,
        closeOnNavigation: false,
        width: '600px',
        panelClass: 'fullscreen',
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/plan-select-dialog/plan-select-dialog.component'
      ).then(c => c.PlanSelectDialogComponent),
  },

  {
    path: DialogNames.imageCrop,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: '600px',
        panelClass: 'fullscreen',
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/image-crop-dialog/image-crop-dialog.component'
      ).then(c => c.ImageCropDialogComponent),
  },

  {
    path: DialogNames.gallery,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        panelClass: 'fullscreen',
      },
    },
    loadComponent: () =>
      import('./standalone-dialogs/gallery/gallery.component').then(
        c => c.GalleryComponent
      ),
  },
  {
    path: DialogNames.colorPicker,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        panelClass: 'fullscreen',
        width: '600px',
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/color-picker-dialog/color-picker-dialog.component'
      ).then(c => c.ColorPickerDialogComponent),
  },

  {
    path: DialogNames.secureConfirm,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        autoFocus: false,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/secure-confirm-dialog/secure-confirm-dialog.component'
      ).then(c => c.SecureConfirmDialogComponent),
  },

  {
    path: DialogNames.numericKeyboard,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: '550px',
        height: '90vh',
        maxHeight: '700px',
        panelClass: 'fullscreen',
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/numeric-keyboard-dialog/numeric-keyboard-dialog.component'
      ).then(c => c.NumericKeyboardDialogComponent),
  },

  {
    path: DialogNames.deliveryDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        minWidth: '600px',
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/delivery-dialog/delivery-dialog.component'
      ).then(c => c.DeliveryDialogComponent),
  },

  {
    path: DialogNames.createItem,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        panelClass: 'fullscreen',
        ...createParticipantDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/create-participant-dialog/create-participant-dialog.component'
      ).then(c => c.CreateParticipantDialogComponent),
  },
  {
    path: DialogNames.selectDealType,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...dealTypeSelectionDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/deal-type-selection-dialog/deal-type-selection-dialog.component'
      ).then(c => c.DealTypeSelectionDialogComponent),
  },
  {
    path: DialogNames.closedDealStepper,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...closedDealStepperDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/closed-deal-stepper-dialog/closed-deal-stepper-dialog.component'
      ).then(c => c.ClosedDealStepperDialogComponent),
  },
  {
    path: DialogNames.closedDealEntryMethod,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...closedDealEntryMethodDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/closed-deal-entry-method-dialog/closed-deal-entry-method-dialog.component'
      ).then(c => c.ClosedDealEntryMethodDialogComponent),
  },
  {
    path: DialogNames.currentDealEntryMethod,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...currentDealEntryMethodDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/current-deal-entry-method-dialog/current-deal-entry-method-dialog.component'
      ).then(c => c.CurrentDealEntryMethodDialogComponent),
  },
  {
    path: DialogNames.termSheetReview,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...termSheetReviewDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/term-sheet-review-dialog/term-sheet-review-dialog.component'
      ).then(c => c.TermSheetReviewDialogComponent),
  },
  {
    path: DialogNames.benchmarkPublish,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...benchmarkPublishDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/benchmark-publish-dialog/benchmark-publish-dialog.component'
      ).then(c => c.BenchmarkPublishDialogComponent),
  },
  {
    path: DialogNames.employeeDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...employeeDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/employee-dialog/employee-dialog.component'
      ).then(c => c.EmployeeDialogComponent),
  },
  {
    path: DialogNames.inviteContact,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...inviteContactDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/invite-contact-dialog/invite-contact-dialog.component'
      ).then(c => c.InviteContactDialogComponent),
  },
  {
    path: DialogNames.promptData,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        autoFocus: true,
        maxWidth: '100%',
        width: '700px',
      },
    },
    loadComponent: () =>
      import('./standalone-dialogs/prompt-dialog/prompt-dialog.component').then(
        c => c.PromptDialogComponent
      ),
  },
  {
    path: DialogNames.customerDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        panelClass: 'fullscreen',
        width: '500px',
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/customer-dialog/customer-dialog.component'
      ).then(c => c.CustomerDialogComponent),
  },
  {
    path: DialogNames.noteDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...defaultDialogConfig,
        width: 'auto',
        maxWidth: '95vw',
        height: '85vh',
        disableClose: true,
      },
    },
    loadComponent: () =>
      import('./standalone-dialogs/note-dialog/note-dialog.component').then(
        c => c.NoteDialogComponent
      ),
  },
  {
    path: DialogNames.informationDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...informationDialogConfig,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/information-dialog/information-dialog.component'
      ).then(c => c.InformationDialogComponent),
  },
  {
    path: DialogNames.fileUploaderDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: '1000px',
        maxWidth: '90vw',
        minHeight: '400px',
        height: 'auto',
        maxHeight: '90vh',
        disableClose: false,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/file-uploader-dialog/file-uploader-dialog.component'
      ).then(c => c.FileUploaderDialogComponent),
  },
  {
    path: DialogNames.ndaDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...ndaDialogConfig,
      },
    },
    loadComponent: () =>
      import('./standalone-dialogs/nda-dialog/nda-dialog.component').then(
        c => c.NdaDialogComponent
      ),
  },

  {
    path: DialogNames.companyNdasUpload,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: 'clamp(600px, 80vw, 1400px)',
        height: 'auto',
        maxWidth: '95vw',
        maxHeight: '90vh',
        autoFocus: false,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/contact-ndas-upload-dialog/contact-ndas-upload-dialog.component'
      ).then(c => c.ContactNdasUploadDialogComponent),
  },

  {
    path: DialogNames.companyNdasPreview,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: '90vw',
        maxWidth: '1200px',
        height: '80vh',
        maxHeight: '800px',
        autoFocus: false,
      },
    },
    loadComponent: () =>
      import(
        './standalone-dialogs/contact-ndas-preview-dialog/contact-ndas-preview-dialog.component'
      ).then(c => c.ContactNdasPreviewDialogComponent),
  },
  {
    path: DialogNames.taskDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        width: 'auto',
        maxWidth: '95vw',
        maxHeight: '90vh',
        minWidth: '700px',
        autoFocus: false,
        disableClose: false,
      },
    },
    loadComponent: () =>
      import('@qtek/libs/tasks').then(c => c.TasksDialogComponent),
  },

  //
  // MODULE       ////////////////////////////////////
  //
  {
    path: DialogNames.contactDialog,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        panelClass: 'fullscreenAll',
      },
    },
    loadChildren: () =>
      import('./module-dialogs/contact-dialog/contact-dialog.module').then(
        m => m.ContactDialogModule
      ),
  },
  {
    path: DialogNames.contactPreview,
    canActivate: [LazyDialogLoader],
    data: {
      dialogConfig: {
        ...contactPreviewDialogConfig,
      },
    },
    loadChildren: () =>
      import(
        './module-dialogs/contact-preview-dialog/contact-preview-dialog.module'
      ).then(m => m.ContactPreviewDialogModule),
  },
];
